import React from 'react';

var SvgInformationCircleLg = function SvgInformationCircleLg(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 8.875c.345 0 .625.28.625.625v8.125c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-8.125c0-.345.28-.625.625-.625",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5.75c.345 0 .625.28.625.625v.625c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-.625c0-.345.28-.625.625-.625",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.25 12c0 4.833 3.918 8.75 8.75 8.75 4.833 0 8.75-3.918 8.75-8.75s-3.918-8.75-8.75-8.75-8.75 3.918-8.75 8.75m8.75-10c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10",
    clipRule: "evenodd"
  }));
};
SvgInformationCircleLg.displayName = "InformationCircleLg";

export { SvgInformationCircleLg as S };
